import React, { useEffect, useState } from 'react';
import { InvoiceDto } from '../../models/invoice.dto';
import ModalContainer from '../layout/modal-container';
import { useTranslation } from 'react-i18next';
import { useUpdateInvoiceMutation } from '../../store/invoices/invoices.api';
import DatePicker from 'react-datepicker';
import { PaymentDateButton } from '../invoices-list/action-dropdown/payment-date-field';
import './payment-date-modal.scss';

type DialogTheme = 'light' | 'dark';

interface PropsType {
   invoice: InvoiceDto;
   showEditDateModal: boolean;
   setShowEditDateModal: (showEditDateModal: boolean) => void;
   theme?: DialogTheme;
}

const PaymentDateModal = ({
   invoice, showEditDateModal, setShowEditDateModal, theme = 'light'
}: PropsType) => {
   const [paymentDate, setPaymentDate] = useState(
      invoice.paymentDate ? new Date(invoice.paymentDate) : new Date(),
   );

   const [translate] = useTranslation(['account', 'common', 'invoice']);
   const [updateInvoice] = useUpdateInvoiceMutation();

   useEffect(() => {
      if (showEditDateModal) {
         setPaymentDate(invoice.paymentDate ? new Date(invoice.paymentDate) : new Date());
      }
   }, [invoice.paymentDate, showEditDateModal]);

   const handleSaveEditPaymentDate = () => {
      updateInvoice({
         invoiceId: invoice.invoiceId,
         data: { ...invoice, paymentDate: paymentDate.toISOString() },
      });
      setShowEditDateModal(false);
   };

   const datePicker = (
      <DatePicker
         selected={paymentDate}
         dateFormat='dd-MM-yyyy'
         onKeyDown={(e) => e.preventDefault()}
         onChange={(date: Date | null) => date && setPaymentDate(date)}
         popperPlacement='top-end'
         popperModifiers={[{ name: 'flip', enabled: false }]}
         popperClassName='payment-date-popper edit-payment-date-popper'
         portalId='payment-date-modal-calendar-portal'
         wrapperClassName='edit-payment-date-picker'
         customInput={<PaymentDateButton />}
         showPopperArrow={false}
      />
   );

   return (
      <ModalContainer
         modalContent={datePicker}
         modalHeader={translate('invoice:invoice.editPaymentDate')}
         submitButtonText={translate('common:common.save')}
         show={showEditDateModal}
         onCancel={() => setShowEditDateModal(false)}
         onSubmit={handleSaveEditPaymentDate}
         dialogClassName={`payment-date-dialog ${theme === 'dark' ? 'modal-dark' : ''}`}
      ></ModalContainer>
   );
};

export default PaymentDateModal;
